import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const checkboxDefaultVariants = {}
const checkboxCompoundVariants = [
  {
    "selected": true,
    "disabled": true,
    "css": {
      "control": {
        "background": "interactive.disabled",
        "borderColor": "border.disabled"
      },
      "indicator": {
        "color": "content.disabled"
      }
    }
  },
  {
    "indeterminate": true,
    "disabled": true,
    "css": {
      "control": {
        "background": "interactive.disabled",
        "borderColor": "border.disabled"
      },
      "indicator": {
        "color": "content.disabled"
      }
    }
  }
]

const checkboxSlotNames = [
  [
    "root",
    "Checkbox__root"
  ],
  [
    "label",
    "Checkbox__label"
  ],
  [
    "control",
    "Checkbox__control"
  ],
  [
    "indicator",
    "Checkbox__indicator"
  ],
  [
    "message",
    "Checkbox__message"
  ]
]
const checkboxSlotFns = /* @__PURE__ */ checkboxSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, checkboxDefaultVariants, getSlotCompoundVariant(checkboxCompoundVariants, slotName))])

const checkboxFn = memo((props = {}) => {
  return Object.fromEntries(checkboxSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const checkboxVariantKeys = [
  "error",
  "focusVisible",
  "selected",
  "indeterminate",
  "disabled"
]
const getVariantProps = (variants) => ({ ...checkboxDefaultVariants, ...compact(variants) })

export const checkbox = /* @__PURE__ */ Object.assign(checkboxFn, {
  __recipe__: false,
  __name__: 'checkbox',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: checkboxVariantKeys,
  variantMap: {
  "error": [
    "true"
  ],
  "focusVisible": [
    "true",
    "false"
  ],
  "selected": [
    "true"
  ],
  "indeterminate": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, checkboxVariantKeys)
  },
  getVariantProps
})